import { Container, Grid, Text, Box, Rating, Divider, useMantineTheme, Skeleton } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import React from 'react';
import NoDataFound from '../../components/NoDataFound';
import { useGetReviews } from '../../services/review/review.service';
import { useParams } from 'react-router-dom';
import { ReviewScrollArea } from './style';
import { convertTo24HourFormat } from '../../config/Helper';

const ReviewList = () => {
  const mantinetheme = useMantineTheme();
  const mobile = useMediaQuery(`(max-width: ${mantinetheme.breakpoints.sm})`);
  const { restaurantId } = useParams<{ restaurantId: string }>();

  const { data, isSuccess, isLoading, isFetching, isRefetchError, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useGetReviews(restaurantId);

  const scrollHandler = async (e: any) => {
    const totalHeight = e.target.clientHeight + e.target.scrollTop;
    if (totalHeight >= e.target.scrollHeight - 50 && !isFetching && !isLoading && hasNextPage && !isRefetchError) {
      fetchNextPage();
    }
  };

  return (
    <>
      <Container>
        <Grid>
          <Grid.Col span={2} ta='left'>
            <Text fz='16px' fw={500} color='black'>
              REVIEWS
            </Text>
          </Grid.Col>
        </Grid>

        <ReviewScrollArea onScroll={scrollHandler}>
          {isSuccess && Array.isArray(data?.pages)
            ? data?.pages.map((element: any, index: number) => (
                <React.Fragment key={index}>
                  {element?.data.length ? (
                    element?.data?.map((item: any, index: number) => (
                      <React.Fragment key={index}>
                        <Box fw={500} p='10px 10px 5px 10px'>
                          <Text align='left' fz={mobile ? '12px' : '14px'} color='black'>
                            {' '}
                            {item.comment}
                          </Text>
                          <Rating pt='5px' size={mobile ? 'xs' : 'sm'} value={item.rating} fractions={2} readOnly />
                          <Text align='left' pt={5} fz={mobile ? '11px' : '13px'} color='black'>
                            {item.user.name}
                          </Text>
                          <Text align='left' pt={2} fz={mobile ? '11px' : '13px'} color='red'>
                            {convertTo24HourFormat(item.updated_at)}
                          </Text>
                        </Box>
                        <Divider my='xs' color='#B6B6B6' />
                      </React.Fragment>
                    ))
                  ) : (
                    <NoDataFound text='No review found for this resturant' />
                  )}
                </React.Fragment>
              ))
            : null}
          {isLoading || isFetchingNextPage
            ? Array(2)
                .fill(0)
                .map((d, index) => (
                  <Box key={index}>
                    <Skeleton height={20} width='100%' radius='xl' />
                    <Skeleton height={30} mt={5} width='10%' radius='xl' />
                    <Skeleton height={20} mt={5} width='30%' radius='xl' />
                    <Skeleton height={20} mt={2} width='50%' radius='xl' />
                    <Divider my='xs' color='#B6B6B6' />
                  </Box>
                ))
            : null}
        </ReviewScrollArea>
      </Container>
    </>
  );
};

export default ReviewList;
